var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 3.75C19.2041 3.75 15 7.9541 15 13.125V28.125C15 33.2959 19.2041 37.5 24.375 37.5C26.499 37.5 28.4326 36.7676 30 35.5664V28.5938L29.9561 28.5059C29.751 31.4355 27.334 33.75 24.375 33.75C21.2695 33.75 18.75 31.2305 18.75 28.125V13.125C18.75 10.0195 21.2695 7.5 24.375 7.5C27.4805 7.5 30 10.0195 30 13.125V22.1191L33.75 24.3457V13.125C33.75 7.9541 29.5459 3.75 24.375 3.75ZM7.5 26.25V28.125C7.5 36.7822 14.0918 43.8574 22.5 44.8096V52.5H15V56.25H30V52.5H26.25V44.8242C27.5391 44.6484 28.7988 44.3994 30 43.96V39.917C28.2568 40.7666 26.3525 41.25 24.375 41.25C17.1387 41.25 11.25 35.3613 11.25 28.125V26.25H7.5ZM33.75 29.9707V59.0918L36.5918 57.3926L58.0225 44.5312L33.75 29.9707ZM37.5 36.5918L50.7275 44.5312L37.5 52.4561V36.5918Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI9);
export default __webpack_public_path__ + "static/media/i9.51e3c0061c937d24ddbca1ab61c31c5c.svg";
export { ForwardRef as ReactComponent };